import { DropdownMenu } from "./DropdownMenu.js";

/**
 * Class to implement the dropdown-menu manager
 * as a singleton, which can be instantiated
 * by any other extension as a dependency
 */
export class DropdownMenuManager {
    private static manager: DropdownMenuManager;
    private instances: DropdownMenu[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.dropdownMenus.forEach((dropdownMenu) => {
            this.instances.push(new DropdownMenu(dropdownMenu));
        });
    }

    /**
     * Method to instantiate all
     * dropdown-menus on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {DropdownMenuManager}
     */
    public static use(reset: boolean = false): DropdownMenuManager {
        if (!DropdownMenuManager.manager || reset) {
            DropdownMenuManager.manager = new DropdownMenuManager();
        }
        return DropdownMenuManager.manager;
    }

    /**
     * Selects the dropdown-menus
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get dropdownMenus(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(
            `[scope="header-main-menu"][template="dropdown"]`,
        );
    }

    /**
     * Returns the number of instantiated dropdown-menus
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
